module.exports = __webpack_public_path__ + "img/broadcast-work-icon8.b34f8c2a.png";